"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PayStubs;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const PayStubs_1 = __importDefault(require("../api/PayStubs"));
const UserContext_1 = require("../contexts/UserContext");
const Screen_1 = __importDefault(require("../components/Screen"));
const Card_1 = __importDefault(require("../components/Card"));
const Loading_1 = __importDefault(require("../components/Loading"));
const List_1 = __importDefault(require("../components/List"));
const TableHeader_1 = __importDefault(require("../components/TableHeader"));
const Button_1 = __importDefault(require("../components/Button"));
const PayStub_1 = __importDefault(require("../partials/PayStub"));
const react_i18next_1 = require("react-i18next");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return react_native_1.StyleSheet.create({
        header: {
            color: THEME.Text,
            fontSize: 24,
            fontWeight: '500',
            marginTop: -2,
            textAlign: 'center'
        },
        buttonText: {
            fontSize: 16,
            fontWeight: '500'
        },
        flex: {
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'center'
        }
    });
};
function PayStubs(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const styles = useStyles();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState(null);
    const [payStubs, setPayStubs] = react_1.default.useState(null);
    const [year, setYear] = react_1.default.useState(Number.parseInt(props.route.params.year));
    const [refreshing, setRefreshing] = react_1.default.useState(false);
    const onRefresh = react_1.default.useCallback(() => {
        setRefreshing(true);
        refresh().then(() => setRefreshing(false));
        return () => promise.current?.cancel();
    }, [year]);
    const refresh = react_1.default.useCallback(async () => {
        promise.current?.cancel();
        setStatus('loading');
        props.navigation.setParams({ year: year });
        setPayStubs(null);
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => PayStubs_1.default.getList(token, year.toString()))).then(data => {
            setPayStubs(data);
            setStatus('done');
        }).catch(e => {
            setPayStubs(null);
            setStatus((e == 404) ? 'done' : 'error');
        });
    }, [year]);
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, [year]);
    const payStubClick = (id, date) => {
        props.navigation.navigate('PayStubDetail', { voucherId: id, date });
    };
    return ((0, jsx_runtime_1.jsx)(Screen_1.default, { onRefresh: onRefresh, refreshing: refreshing, children: (0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginTop: 6, marginBottom: 12, flexDirection: 'row', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsxs)(Button_1.default, { "aria-label": (year - 1).toString(), accessibilityHint: t('myPay:hints.pressStubs') + (year - 1).toString(), color: THEME.Secondary, onPress: () => setYear(year - 1), children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.ChevronLeft, size: 12, color: THEME.AlwaysWhite, style: { marginTop: 2, marginRight: 4 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: [styles.buttonText, { color: THEME.AlwaysWhite }], children: year - 1 })] }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 2 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.header, children: year }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsxs)(Button_1.default, { "aria-label": (year + 1).toString(), accessibilityHint: t('myPay:hints.pressStubs') + (year + 1).toString(), color: THEME.Secondary, disabled: year >= (new Date()).getFullYear(), onPress: () => setYear(year + 1), children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: [styles.buttonText, { color: year >= (new Date()).getFullYear() ? THEME.TextDisabled : THEME.AlwaysWhite }], children: year + 1 }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.ChevronRight, size: 12, color: year >= (new Date()).getFullYear() ? THEME.TextDisabled : THEME.AlwaysWhite, style: { marginTop: 2, marginLeft: 4 } })] }) })] }), (0, jsx_runtime_1.jsx)(TableHeader_1.default, { columns: [
                        { flex: 2, label: '' },
                        { flex: 4, label: t('myPay:text.date') },
                        { flex: 4, label: t('myPay:text.net') },
                        { flex: 1, label: '' },
                    ] }), (0, jsx_runtime_1.jsx)(List_1.default, { data: payStubs, keyExtractor: (item, index) => item.voucherId, itemSeparator: () => ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: STYLES.separator })), renderItem: (item, index) => ((0, jsx_runtime_1.jsx)(FadeInView_1.default, { children: (0, jsx_runtime_1.jsx)(PayStub_1.default, { item: item, showYear: false, label: (year == (new Date()).getFullYear() && index == 0) ? t('myPay:text.latest') : null, onPress: () => payStubClick(item.voucherId, item.payDate) }) })), listEmpty: () => (status == 'done')
                        &&
                            (0, jsx_runtime_1.jsx)(FadeInView_1.default, { style: { margin: 8, marginTop: 16 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { alignItems: "center", justifyContent: "center", marginVertical: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.MoneyCheckDollar, size: 48, color: THEME.ImageNull, style: { marginBottom: 6 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontSize: size != 'sm' ? 16 : 14, color: THEME.TextNull, textAlign: 'center' }, children: t('myPay:text.noStubsYear') + year })] }) })
                        ||
                            (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() }) })] }) }));
}
;
